import { DripsyFinalTheme } from 'dripsy';
import _ from 'lodash';
import React from 'react';
import { useStore } from '../../store/store';
import { useBrand } from './brand';

interface UseTheme {
  appTheme: DripsyFinalTheme;
}

export const useBrandedTheme = (): UseTheme => {
  const { brand, theme } = useStore();
  const brandConfig = useBrand(brand);
  if (!brandConfig) {
    throw new Error(`Brand not found ${brand}`);
  }

  const appTheme = {
    light: brandConfig?.theme.light,
    dark: brandConfig?.theme.dark
  };

  return {
    appTheme: appTheme[theme]
  };
};
